<template>

    <div>

        <div class="row mt-3">
            <div class="col"><a href="#" @click.prevent="eraseLevelOneSelection"><i class="mr-2 fas fa-chevron-left" aria-label="Go Back"></i>{{cmsContentBlocks['templateSelector.2ndLevelPage.AllMesssageTypeBack']}}</a></div>
        </div>

        <div class="row mt-3">
            <div class="col no-padding">
                <hr class="mt-0 mb-0 border-none taller-hr">
            </div>
        </div>

        <div class="row mt-3">
            <div class="col">

                <div class="row">
                    <div class="col">
                        <h6>To the {{selectedRecord.title}}</h6>
                    </div>
                </div>

                <div class="row mt-2" v-for="template in selectedRecord.children">
                    <div class="col">
                        <template-record-link :template-record="template"
                                              :title-to-output="template.title"
                                              @itemSelected="templateClicked" />
                    </div>
                </div>

            </div>
        </div>

    </div>

</template>

<script>

    import Vue from 'vue';
    import templateRecordLink from './template.selector.link.record.vue';

    export default {
        name: 'templateRecordSelectorSecondLevel',
        props: {
            selectedRecord: { type: Object },
            cmsContentBlocks: {},
        },
        components: {
            'template-record-link': templateRecordLink
        },
        methods: {

            templateClicked: function (template) {
                this.$emit('templateClicked', template);
            },

            eraseLevelOneSelection: function () {
                this.$emit('eraseLevelOneSelection');
            }

        }
    };
</script>

